import type { GroupMember } from './groupsApi.ts';
import { usePrefersLight } from './useMemberColour.ts';

/**
 * A member's name in their own colour.
 *
 * The colour is always accompanied by the name, never used alone to identify someone.
 * Colour makes "who has already got the milk" answerable at a glance; the text is what
 * makes it answerable at all for someone who cannot distinguish the two colours in play.
 */
export function MemberChip({ member, showRole = false }: { member: GroupMember; showRole?: boolean }) {
  const prefersLight = usePrefersLight();
  const colour = prefersLight ? member.colourOnLight : member.colourHex;

  return (
    <span className="member-chip">
      <span
        className="member-chip__swatch"
        style={{ backgroundColor: colour }}
        // The swatch duplicates information already in the text, so it is decorative.
        aria-hidden="true"
      />
      <span className="member-chip__name" style={{ color: colour }}>
        {member.displayName}
      </span>
      {showRole && member.role === 'Owner' && <span className="member-chip__role">owner</span>}
    </span>
  );
}
